import { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { CommonInput, CommonLabel, FlexBox, INPUT_TYPES, useIsMobile, useToasts } from "@brg/ui";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { ProjectEditPageGridRow } from "shared/components/ProjectEditPageGrid";
import { checkLinkForErrors, EMAIL_MAX_LENGTH, VALIDATE_LINK_TYPES } from "shared/utils/validate";
import DeleteIcon from "shared/icons/DeleteIcon";
import { DefaultButton } from "../styles";

const EmailTag = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #909090;
    border-radius: 5px;
    padding: 5px 16px;
    flex-shrink: 0;
`

const EmailTagText = styled.span`
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: -0.3px;
    color: #151514;
    white-space: nowrap;
`

const EmailTagRemoveBtn = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    flex-shrink: 0;

    svg {
        width: 12px;
        height: 12px;
    }

    &:hover { opacity: 0.6; }
`

type AdminEmailsToReceiveDataFieldProps = {
    value: string[];
    onChange: (emails: string[]) => void;
}

export const AdminEmailsToReceiveDataField: FC<AdminEmailsToReceiveDataFieldProps> = ({ value, onChange }) => {
    const { t } = useTranslation();
    const toasts = useToasts();
    const isMobile = useIsMobile();
    const [inputValue, setInputValue] = useState('');

    const handleAdd = useCallback(() => {
        const trimmedEmail = inputValue.trim();
        if (!trimmedEmail) {
            return;
        }

        if (checkLinkForErrors(trimmedEmail, VALIDATE_LINK_TYPES.email)) {
            toasts.error(t('teams.adminPage.additionalFields.form_admin_email_invalid'));
            return;
        }

        if (!value.includes(trimmedEmail)) {
            onChange([...value, trimmedEmail]);
        }
        setInputValue('');
    }, [inputValue, value, onChange, t, toasts]);

    const handleKeyDown = useCallback((ev: any) => {
        if (ev.key === 'Enter') {
            ev.preventDefault();
            handleAdd();
        }
    }, [handleAdd]);

    const handleRemove = useCallback((email: string) => {
        onChange(value.filter((item) => item !== email));
    }, [value, onChange]);

    return (
        <ProjectEditPageGridRow style={{marginTop: isMobile ? 24 : 32}} isTeamEdit>
            <CommonLabel
                label={t('teams.adminPage.fields.form_admin_emails_to_receive_data')}
                infoText={t('teams.adminPage.additionalFields.form_admin_emails_to_receive_data_info')}
                onWhiteBG
                fixedHeight
            />
            <ProjectEditPageGridInput direction="column">
                <FlexBox align="center" gx={8} width={'100%'}>
                    <CommonInput
                        type={INPUT_TYPES.text}
                        maxLength={EMAIL_MAX_LENGTH}
                        value={inputValue}
                        onChange={(ev: any) => setInputValue(ev.target.value)}
                        onKeyDown={handleKeyDown}
                        orientation="wide"
                    />
                    {!!inputValue.trim() && (
                        <DefaultButton wh={131} whMob={107} onClick={handleAdd}>
                            {t('teams.adminPage.fields.form_add')}
                        </DefaultButton>
                    )}
                </FlexBox>
                {!!value.length && (
                    <FlexBox wrap="wrap" gx={12} offsetTop={12}>
                        {value.map((email) => (
                            <EmailTag key={email}>
                                <EmailTagText>{email}</EmailTagText>
                                <EmailTagRemoveBtn type="button" onClick={() => handleRemove(email)}>
                                    <DeleteIcon />
                                </EmailTagRemoveBtn>
                            </EmailTag>
                        ))}
                    </FlexBox>
                )}
            </ProjectEditPageGridInput>
        </ProjectEditPageGridRow>
    );
};

export default AdminEmailsToReceiveDataField;
import { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { CommonInput, CommonLabel, FlexBox, INPUT_TYPES, useIsMobile, useToasts } from "@brg/ui";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { ProjectEditPageGridRow } from "shared/components/ProjectEditPageGrid";
import { checkLinkForErrors, EMAIL_MAX_LENGTH, VALIDATE_LINK_TYPES } from "shared/utils/validate";
import DeleteIcon from "shared/icons/DeleteIcon";
import { DefaultButton } from "../styles";

const EmailTag = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #909090;
    border-radius: 5px;
    padding: 5px 16px;
    flex-shrink: 0;
`

const EmailTagText = styled.span`
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: -0.3px;
    color: #151514;
    white-space: nowrap;
`

const EmailTagRemoveBtn = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    flex-shrink: 0;

    svg {
        width: 12px;
        height: 12px;
    }

    &:hover { opacity: 0.6; }
`

type AdminEmailsToReceiveDataFieldProps = {
    value: string[];
    onChange: (emails: string[]) => void;
}

export const AdminEmailsToReceiveDataField: FC<AdminEmailsToReceiveDataFieldProps> = ({ value, onChange }) => {
    const { t } = useTranslation();
    const toasts = useToasts();
    const isMobile = useIsMobile();
    const [inputValue, setInputValue] = useState('');

    const handleAdd = useCallback(() => {
        const trimmedEmail = inputValue.trim();
        if (!trimmedEmail) {
            return;
        }

        if (checkLinkForErrors(trimmedEmail, VALIDATE_LINK_TYPES.email)) {
            toasts.error(t('teams.adminPage.additionalFields.form_admin_email_invalid'));
            return;
        }

        if (!value.includes(trimmedEmail)) {
            onChange([...value, trimmedEmail]);
        }
        setInputValue('');
    }, [inputValue, value, onChange, t, toasts]);

    const handleKeyDown = useCallback((ev: any) => {
        if (ev.key === 'Enter') {
            ev.preventDefault();
            handleAdd();
        }
    }, [handleAdd]);

    const handleRemove = useCallback((email: string) => {
        onChange(value.filter((item) => item !== email));
    }, [value, onChange]);

    return (
        <ProjectEditPageGridRow style={{marginTop: isMobile ? 24 : 32}} isTeamEdit>
            <CommonLabel
                label={t('teams.adminPage.fields.form_admin_emails_to_receive_data')}
                infoText={t('teams.adminPage.additionalFields.form_admin_emails_to_receive_data_info')}
                onWhiteBG
                fixedHeight
            />
            <ProjectEditPageGridInput direction="column">
                <FlexBox align="center" gx={8} width={'100%'}>
                    <CommonInput
                        type={INPUT_TYPES.text}
                        maxLength={EMAIL_MAX_LENGTH}
                        value={inputValue}
                        onChange={(ev: any) => setInputValue(ev.target.value)}
                        onKeyDown={handleKeyDown}
                        orientation="wide"
                    />
                    {!!inputValue.trim() && (
                        <DefaultButton wh={131} whMob={107} onClick={handleAdd}>
                            {t('teams.adminPage.fields.form_add')}
                        </DefaultButton>
                    )}
                </FlexBox>
                {!!value.length && (
                    <FlexBox wrap="wrap" gx={12} offsetTop={12}>
                        {value.map((email) => (
                            <EmailTag key={email}>
                                <EmailTagText>{email}</EmailTagText>
                                <EmailTagRemoveBtn type="button" onClick={() => handleRemove(email)}>
                                    <DeleteIcon />
                                </EmailTagRemoveBtn>
                            </EmailTag>
                        ))}
                    </FlexBox>
                )}
            </ProjectEditPageGridInput>
        </ProjectEditPageGridRow>
    );
};

export default AdminEmailsToReceiveDataField;
